<template>
  <div class="developer-processor-associations">
    <BaseCard
      :has-divider="true"
      :has-main-container="true"
      base-card-title-class="app-font-semibold title mb-1"
      data-v-step="0"
    >
      <template v-slot:header-title>
        Meus Processadores
      </template>
      <template v-slot:header-actions>
        <v-dialog
          :value="isModalAddOrViewActive"
          persistent
          :max-width="modalAddOrEdit.context != 'update' ? 600 : ''"
          :content-class="modalAddOrEdit.context == 'update' ? 'v-dialog--fullscreen' : ''"
          :transition="modalAddOrEdit.context == 'update' ? 'app-transition-to-right' : ''"
          @input="changeModalContext('create')"
        >
          <template v-slot:activator="{ on }">
            <BaseButton
              type="text"
              color="blueff"
              class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
              v-on="on"
            >
              Adicionar
            </BaseButton>
          </template>
          <BaseModal
            :style="{ 'height' : modalAddOrEdit.context == 'update' ? '100vh' : 'unset', 'flex-wrap': modalAddOrEdit.context == 'update' ? 'nowrap' : 'unset' }"
            :show-indeterminate-progress="modalAddOrEdit.showIndeterminateProgress"
            :disable-body-scroll="modalAddOrEdit.disableBodyScroll"
            :top-slot-content-title="modalAddOrEdit.topSlotContentTitle"
            :remove-button-close="modalAddOrEdit.removeButtonClose"
            :middle-slot-content-text-highlight="modalAddOrEdit.middleSlotContentTextHighlight"
            :middle-slot-content-text="modalAddOrEdit.middleSlotContentText"
            :middle-check-agree="modalAddOrEdit.middleCheckAgree"
            :bottom-buttons-align="modalAddOrEdit.bottomButtonsAlign"
            :bottom-slot-content-button-cancel-label="modalAddOrEdit.bottomSlotContentButtonCancelLabel"
            :bottom-slot-content-button-confirm-label="modalAddOrEdit.bottomSlotContentButtonConfirmLabel"
            :remove-button-cancel="modalAddOrEdit.removeButtonCancel"
            :remove-button-confirm="modalAddOrEdit.removeButtonConfirm"
            :custom-enable-bottom-button-confirm-label="(valid && modalAddOrEdit.middleCheckAgree == null) || (modalAddOrEdit.middleCheckAgree !== null && modalAddOrEdit.middleCheckAgree.isChecked) || processorObjectAreEdited || modalAddOrEdit.context == 'deploy'"
            :modal-full-screen="true"
            @on-cancel="modalAddOrEdit.onCancel"
            @on-confirm="modalAddOrEdit.onConfirm"
            @input="(value) => checkAgree(value)"
          >
            <template
              v-if="modalAddOrEdit.middleSlotContentText == ''"
              v-slot:default
            >
              <div
                v-if="modalAddOrEdit.context == 'create'"
                style="margin: 0 auto"
              >
                <v-form
                  ref="formAddOrView"
                  v-model="valid"
                >
                  <v-container>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <BaseInput
                          v-model="processor.context"
                          :rules="[isValid]"
                          qa-identification-name="qa-id-name-processor-name"
                          label="Context *"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="processor.eventType"
                          :items="eventTypesList"
                          :rules="[isValid]"
                          item-text="type"
                          item-value="uuid"
                          label="Event Type *"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="processor.eventProcessor"
                          :items="eventProcessorsList"
                          :rules="[isValid]"
                          item-text="name"
                          item-value="name"
                          label="Event Processor *"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <BaseInput
                          v-model="processor.alias"
                          qa-identification-name="qa-id-name-processor-code"
                          persistent-hint
                          hint="Digite um alias para facilitar a identificação"
                          label="Alias"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <v-autocomplete
                          v-model="processor.initiator"
                          :items="getInitiatorsWithDefault"
                          :rules="[isValid]"
                          return-object
                          item-text="code"
                          item-value="code"
                          label="Initiator *"
                        >
                          <template v-slot:item="{ item }">
                            <v-list-item-content>
                              <v-list-item-title>{{ item.code }}</v-list-item-title>
                              <v-list-item-subtitle>{{ item.name }}</v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <BaseInput
                          v-model="processor.matchers"
                          qa-identification-name="qa-id-name-processor-code"
                          label="Matchers"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <BaseInput
                          v-model="processor.parent_processor"
                          qa-identification-name="qa-id-name-processor-code"
                          disabled
                          label="Parent Processor"
                        />
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col
                        cols="auto"
                        sm="12"
                      >
                        <BaseInput
                          v-model="processor.executionStep"
                          qa-identification-name="qa-id-name-processor-code"
                          persistent-hint
                          hint="Nome da etapa da execução (Use 'platform:{Nome-da-etapa}' para definir que este processor faz parte da etapa nomeada da excecução. Use '-' para a etapa ser ignorada)"
                          label="Execution Step"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </div>
              <ModalProcessorDetails
                v-if="modalAddOrEdit.context == 'update'"
                :processor-are-edited="processorObjectAreEdited"
                :processor-initiator="processor.initiator"
                :update-processor-api="updateProcessorApi"
                @updateProcessorObjetc="updateProcessorObjetc"
                @onChangeLog="onChangeLog"
                @showDiffModal="getDiffValues"
              />
            </template>
          </BaseModal>
        </v-dialog>
      </template>
      <div
        class="ma-4 mr-8 app-align-items-center"
        style="flex-wrap: wrap;"
      >
        <v-chip
          v-for="item, index in filtersSelected"
          :key="item"
          class="ma-2 ml-0"
          label
          text-color="primary"
          color="secondary"
          close
          @click:close="selectedOnlyDefault ? showMessageInfo = !showMessageInfo : removeFilterList(index) "
        >
          {{ item }}
        </v-chip>
        <v-tooltip
          v-model="showMessageInfo"
          top
        >
          <template v-slot:activator="{ on }">
            <div
              class="mb-6"
              v-on="on"
            />
          </template>
          <span class="mb-3">{{ 'Não é possível remover todos os filtros' }}</span>
        </v-tooltip>
        <div
          id="id-selected-filter"
          class="text-center"
          :style="{'position': 'relative'}"
        >
          <v-menu
            v-model="filterMenu"
            :close-on-content-click="false"
            :nudge-width="200"
            max-width="408"
            offset-y
            attach="#id-selected-filter"
          >
            <template v-slot:activator="{ on }">
              <BaseButton
                type="text"
                class="app-button__link-text app-button--hide-ripple app-button--no-hover px-0"
                v-on="on"
              >
                <v-icon>
                  add
                </v-icon>
                <span class="ml-1">INITIATOR</span>
              </BaseButton>
            </template>

            <v-card
              width="340"
              class="px-4 pb-0 pt-4 text-left"
            >
              <v-autocomplete
                v-model="modelFilter"
                :items="filterListUnique"
                item-text="name"
                item-value="code"
                label="Initiator"
                class="mr-2"
              />
              <v-card-actions class="px-0">
                <BaseButton
                  :is-disabled="!modelFilter"
                  class="ml-0"
                  @click="applyFilter"
                >
                  Aplicar
                </BaseButton>
              </v-card-actions>
            </v-card>
          </v-menu>
        </div>
      </div>
      <v-treeview
        v-model="itemsSelected"
        :selectable="enableExport"
        :items="filteredTree"
        selection-type="leafAll"
        dense
        hoverable
        return-object
        item-key="uuidProcessorConfiguration"
        tabindex="0"
        activatable
        :active.sync="itemsActivated"
        :open.sync="itemsOpened"
        @keydown.native="onKeyDown"
      >
        <template v-slot:prepend="{ item }">
          <div class="app-align-items-center">
            <v-icon
              :color="getIconTree(item.className).color"
              size="18"
            >
              {{ getIconTree(item.className).icon }}
            </v-icon>
          </div>
        </template>
        <template v-slot:label="{ item }">
          <div
            class="app-align-items-center"
            :class="{'processor-item-tree' : hasModalToOpen(item)}"
          >
            <div @click="openTreeModal(item)">
              <span :class="{'text-decoration-line-through': item.matchers == 'false'}">{{ getNameTree(item) }}</span>
              <span
                v-if="item.className == 'processor' && item.alias != ''"
                class="color--text-black-038"
              > ({{ item.name }})</span>
            </div>
            <v-tooltip
              v-if="pasteClassList.includes(item.className) || enableExport && item.className === 'initiator'"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <BaseButton
                  :has-icon="true"
                  color="primary"
                  class="mx-0 ml-2 my-0 pa-4"
                  size="x-small"
                  v-bind="attrs"
                  v-on="on"
                  @click="cancelCopyAction"
                >
                  <v-icon>mdi-close-box</v-icon>
                </BaseButton>
              </template>
              <span>Cancelar</span>
            </v-tooltip>
            <v-tooltip
              v-if="pasteClassList.includes(item.className)"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <BaseButton
                  :has-icon="true"
                  color="primary"
                  class="mx-0 my-0 pa-4"
                  size="x-small"
                  v-bind="attrs"
                  v-on="on"
                  @click="pasteItem(item)"
                >
                  <v-icon>mdi-content-paste</v-icon>
                </BaseButton>
              </template>
              <span>Colar</span>
            </v-tooltip>
            <v-tooltip
              v-else-if="enableExport && item.className === 'initiator'"
              bottom
            >
              <template v-slot:activator="{ on, attrs }">
                <BaseButton
                  :has-icon="true"
                  color="primary"
                  class="mx-0 my-0 pa-4"
                  size="x-small"
                  :is-disabled="!parseItemsSelected.length"
                  v-bind="attrs"
                  v-on="on"
                  @click="downloadYaml(item)"
                >
                  <v-icon>mdi-download-box</v-icon>
                </BaseButton>
              </template>
              <span>Baixar YAML</span>
            </v-tooltip>
            <BaseMenuOptions
              v-else-if="!enableExport && !pasteClassList.length"
              :menu-itens="menuItens"
              :item-data="item"
              size="x-small"
              class="mx-2"
            />
          </div>
        </template>
      </v-treeview>
      <div class="app-align-items-center justify-end my-3 mx-3">
        <p
          v-for="item, index in ['initiator','context','event-type', 'processor']"
          :key="index"
          class="mx-2"
        >
          <v-icon
            :color="getIconTree(item).color"
            size="19"
          >
            {{ getIconTree(item).icon }}
          </v-icon>
          {{ item.toUpperCase() }}
        </p>
      </div>
    </BaseCard>
    <v-dialog
      v-model="simpleModal.active"
      max-width="560"
      persistent
    >
      <BaseModal
        :show-indeterminate-progress="simpleModal.showIndeterminateProgress"
        :top-slot-content-title="simpleModal.topSlotContentTitle"
        :remove-button-close="simpleModal.removeButtonClose"
        :middle-image="simpleModal.middleImage"
        :middle-slot-content-text-highlight="simpleModal.middleSlotContentTextHighlight"
        :middle-slot-content-text="simpleModal.middleSlotContentText"
        :middle-check-agree="simpleModal.middleCheckAgree"
        :bottom-buttons-align="simpleModal.bottomButtonsAlign"
        :bottom-slot-content-button-cancel-label="simpleModal.bottomSlotContentButtonCancelLabel"
        :bottom-slot-content-button-confirm-label="simpleModal.bottomSlotContentButtonConfirmLabel"
        :remove-button-cancel="simpleModal.removeButtonCancel"
        :remove-button-confirm="simpleModal.removeButtonConfirm"
        :custom-enable-bottom-button-confirm-label="simpleModal.customEnableBottomButtonConfirmLabel"
        @on-cancel="simpleModal.onCancel"
        @on-confirm="simpleModal.onConfirm"
      />
    </v-dialog>
    <v-dialog
      :value="isDiffModalActive"
      persistent
      content-class="v-dialog--fullscreen"
      transition="app-transition-to-right"
    >
      <BaseModal
        style="height: 100vh;flex-wrap:nowrap;"
        :show-indeterminate-progress="diffModal.showIndeterminateProgress"
        :top-slot-content-title="diffModal.topSlotContentTitle"
        :remove-button-close="diffModal.removeButtonClose"
        :middle-slot-content-text-highlight="diffModal.middleSlotContentTextHighlight"
        :middle-slot-content-text="diffModal.middleSlotContentText"
        :middle-check-agree="diffModal.middleCheckAgree"
        :bottom-buttons-align="diffModal.bottomButtonsAlign"
        :bottom-slot-content-button-cancel-label="diffModal.bottomSlotContentButtonCancelLabel"
        :bottom-slot-content-button-confirm-label="diffModal.bottomSlotContentButtonConfirmLabel"
        :remove-button-cancel="diffModal.removeButtonCancel"
        :remove-button-confirm="diffModal.removeButtonConfirm"
        :modal-full-screen="true"
        @on-cancel="isDiffModalActive = false"
        @on-confirm="() => {}"
      >
        <BaseButton
          class="ma-0 my-4"
          color="primary"
          @click="isDiffModalActive = false"
        >
          Voltar
        </BaseButton>
        <SchemaConfiguration
          key="developer"
          :radio-options="[{ text: 'Schema', value: 'schema' },{ text: 'Bytes', value: 'bytes' }]"
          :list-schemas="listSchemas"
          :object-value="{ payload: null, oldValue, newValue: newValue || newOriginal, newOriginal, isBase64, ...transformLocalStorage }"
          option-model="schema"
          context="diff"
          class="mt-4"
          @handleClick="hasChangedOutputValues"
          @hasChangedValues="hasChangeOptionValue"
          @encodeDecodeBase64="encodeDecodeBase64"
        />
      </BaseModal>
    </v-dialog>
    <BaseSnackbar
      :active-snackbar="feedback"
      :type-snackbar="feedbackColor"
      :text-snackbar="feedbackMessage"
      @closeSnackbar="feedback = !feedback"
    />
  </div>
</template>

<script>
import BaseModal from '../../BaseModal'
import { mapActions, mapGetters, mapState } from 'vuex'
import BaseSnackbarConfiguration from '../../../mixins/BaseSnackbarConfiguration'
import BaseSnackbar from '../../BaseSnackbar'
import BaseMenuOptions from '../../BaseMenuOptions'
import ModalProcessorDetails from './ModalProcessorDetails'
import SchemaConfiguration from './SchemaConfiguration'
import UtilsLocalStorage from '../../../mixins/UtilsLocalStorage'

export default {
  name: 'DeveloperInitiators',
  components: { BaseModal, BaseSnackbar, BaseMenuOptions, ModalProcessorDetails, SchemaConfiguration },
  mixins: [ BaseSnackbarConfiguration, UtilsLocalStorage ],
  data() {
    return {
      isModalAddOrViewActive: false,
      modalAddOrEdit: {},
      processor: {},
      valid: false,
      filtersSelected: ['DEFAULT'],
      modelFilter: '',
      filterMenu: false,
      processorDetail: '',
      processorParamsCopy: {},
      processorObjectAreEdited: false,
      simpleModal: {
        active: false,
        action: '',
        showIndeterminateProgress: false,
        topSlotContentTitle: "Alterações não salvas",
        removeButtonClose: true,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "<p>Você fez alterações que ainda não foram salvas no processador.</p><br /><p><b>Ao fechar, todas as alterações serão perdidas</b>.</p><br /><p>Deseja fechar o modal sem salvar as mudanças?</p>",
        middleCheckAgree: null,
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Fechar mesmo assim",
        removeButtonCancel: false,
        removeButtonConfirm: false,
        customEnableBottomButtonConfirmLabel: true
      },
      currentLog: {},
      enableExport: false,
      itemsSelected: [],
      itemsActivated: [],
      itemsOpened: [],
      pasteClassList: [],
      currentCopiedNode: {},
      auxPasteItem: 0,
      currentUuidProcessor: null,
      updateProcessorApi: false,
      showMessageInfo: false,
      isDiffModalActive: false,
      diffModal: {
        active: false,
        showIndeterminateProgress: false,
        topSlotContentTitle: "Diferença Input x Output",
        removeButtonClose: true,
        bottomButtonsAlign: "right",
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        bottomSlotContentButtonCancelLabel: "Fechar",
        bottomSlotContentButtonConfirmLabel: "Fechar mesmo assim",
        removeButtonCancel: true,
        removeButtonConfirm: true,
        customEnableBottomButtonConfirmLabel: false
      },
      oldValue: '',
      newValue: null,
      newOriginal: '',
      listSchemas: [],
      transformLocalStorage: null,
      isBase64: false
    }
  },
  computed: {
    ...mapGetters(['getInitiatorsWithDefault', 'getProcessorAssociationInitiators']),
    ...mapState({
      processorAssociations: state => state.common.processorAssociations,
      eventTypesList: state => state.common.eventTypesList,
      eventProcessorsList: state => state.common.eventProcessorsList,
      processorDetailApi: state => state.common.processorDetail
    }),
    filterListUnique() {
      return this.getProcessorAssociationInitiators ? this.getProcessorAssociationInitiators.filter(filter =>
        !this.filtersSelected.filter(f => f == filter).length)
        : []
    },
    menuItens() {
      return [
        {
          text: "Exportar",
          icon: "mdi-tray-arrow-down",
          execute: (item) => {
            this.filtersSelected = [item.uuidProcessorConfiguration]
            this.enableExport = true
          },
          disableButton(item) {
            return this.enableExport ? true : false
          },
          tooltipText: 'Baixe o arquivo ou cancele a ação de exportar.',
          hideButton(item){
            return item.className !== 'initiator'
          }
        },
        {
          text: "Adicionar",
          icon: "mdi-plus",
          execute: (item) => {
            this.changeModalContext('create', item)
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return false
          }
        },
        {
          text: "Copiar",
          icon: "mdi-content-copy",
          execute: (item) => {
            let enablePasteList = {
              'context': ['initiator'],
              'eventType': ['context'],
              'processor': ['eventType', 'processor']
            }
            this.pasteClassList = enablePasteList[item.className]
            this.currentCopiedNode = item
            this.currentUuidProcessor = null
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return item.className === 'initiator'
          }
        },
        {
          text: "Excluir",
          icon: "mdi-trash-can-outline",
          execute: (item) => {
            this.changeModalContext('delete', item)
          },
          disableButton(item) {
            return item.children.length ? true : false
          },
          tooltipText: "Você não pode excluir um processo que possui filhos.",
          hideButton(item){
            return item.className !== 'processor'
          }
        },
        {
          text: "Deploy",
          icon: "mdi-cloud-upload",
          execute: (item) => {
            this.changeModalContext('deploy', item)
          },
          disableButton(item) {
            return false
          },
          hideButton(item){
            return process.env.NODE_ENV == 'production' || item.className !== 'initiator'
          }
        }
      ]
    },
    filteredTree(){
      return this.processorAssociations.filter((initiator, index) => {
        if(this.filtersSelected.includes(initiator.name) || (this.filtersSelected.includes('DEFAULT') && initiator.name == '')){
          initiator.children = initiator.children.map((context)=>{
            context.children = context.children.map((eventType)=>{
              return {
                ...eventType,
                context: context.name,
                initiator: initiator.className === "initiator" ? initiator.name : eventType.initiator,
                uuidProcessorConfiguration: `eventType-${eventType.name}-${context.name}-${initiator.uuidProcessorConfiguration}`
              }
            }).sort((a, b) => a.name.localeCompare(b.name))

            return {
              ...context,
              initiator: initiator.className === "initiator" ? initiator.name : context.initiator,
              uuidProcessorConfiguration: `context-${context.name}-${initiator.uuidProcessorConfiguration}`
            }
          }).sort((a, b) => a.name.localeCompare(b.name))

          return initiator
        }
      })
    },
    parseItemsSelected(){
      let items = this.itemsSelected ? this.itemsSelected.filter(item => item.className === 'processor') : []
      return items.map(item => item.uuidProcessorConfiguration)
    },
    selectedOnlyDefault(){
      return this.filtersSelected == 'DEFAULT' && this.filtersSelected.length == 1
    }
  },
  watch:{
    filtersSelected: {
      handler(val){
        if(val.length > 1){
          this.enableExport = false
        }
      }
    },
    showMessageInfo: {
      handler(tooltip) {
        if(tooltip) {
          setTimeout(() => {
            this.showMessageInfo = false
          }, 2500);
        }
      },
      deep: true
    },
    filteredTree: {
      handler(value) {
        document.querySelector('.v-treeview').focus()
        this.itemsActivated = [value[0]]
      },
      deep: true
    }
  },
  async created(){
    this.setDefaultModal()
    await this.apiGetProcessorAssociations()
    await this.apiGetInitiators()
    await this.apiGetEventProcessors()
    await this.apiGetEventTypes()
    await this.getSchema()
  },
  methods: {
    ...mapActions(['apiGetInitiators', 'apiGetProcessorAssociations', 'apiCreateProcessorAssociation', 'apiDeleteProcessorAssociation', 'apiGetEventProcessors', 'apiGetEventTypes', 'apiGetProcessorAssociationDetail', 'apiUpdateProcessorAssociationDetail', 'apiGetConfigTree', 'apiDeployInitiator', 'apiGetSchemaMessages', 'apiTransformSchemaMessage']),
    onKeyDown(e) {
      const visible = this.getVisibleItems()
      const currentIndex = visible.findIndex(item => item === this.itemsActivated[0])
      const currentItem = visible[currentIndex]

      e.preventDefault()
      switch (e.key) {
        case 'ArrowDown':
          if (currentIndex < visible.length - 1) {
            this.itemsActivated = [visible[currentIndex + 1]]
          }
        break
        case 'ArrowUp':
          if (currentIndex > 0) {
            this.itemsActivated = [visible[currentIndex - 1]]
          }
        break
        case 'ArrowRight':
          if (currentItem && currentItem.children && !this.itemsOpened.includes(currentItem)) {
            this.itemsOpened.push(currentItem)
          }
        break
        case 'ArrowLeft':
          this.itemsOpened = this.itemsOpened.filter(id => id !== this.itemsActivated[0])
        break
        case 'Enter':
          if(currentItem) this.openTreeModal(currentItem)
        break
      }
    },
    async getSchema() {
      this.listSchemas = await this.apiGetSchemaMessages()
      this.transformLocalStorage = this.getInputsTransformLocalStorage()
    },
    getVisibleItems() {
      const result = []
      const getItems = (items) => {
        for (const item of items) {
          result.push(item)
          if (item.children && this.itemsOpened.includes(item)) {
            getItems(item.children)
          }
        }
      }
      getItems(this.filteredTree)
      return result
    },
    getIconTree(className){
      const icon = {
        'initiator': { color: '#2979FF', icon: 'mdi-circle' },
        'context': { color: '#E91E63', icon: 'mdi-square' },
        'eventType': { color: '#fd9727', icon: 'mdi-pentagon' },
        'event-type': { color: '#fd9727', icon: 'mdi-pentagon' },
        'processor': { color: '#00BFA5', icon: 'mdi-rhombus' }
      }
      return icon[className]
    },
    getNameTree(item){
      if(item.className === 'initiator') {
        let alias = JSON.parse(item.alias)
        let itemName = item.name == '' ? 'DEFAULT' : item.name
        return alias.length ? `${itemName} *` : itemName
      } else if(item.className === 'processor'){
       return item.alias != "" ? item.alias : item.name
      } else {
        return item.name
      }
    },
    openTreeModal(item){
      if(this.hasModalToOpen(item)){
        switch (item.className) {
          case 'initiator':
            this.changeModalContext('alias', item)
            break;
          case 'processor':
            this.changeModalContext('update', item)
            break;
          case 'eventType':
            // ABRIR MODAL DE REGRAS
          break;
        }
      }
    },
    hasModalToOpen(item){
      return item.className == 'processor' || item.className == 'eventType' || (item.className == 'initiator' && JSON.parse(item.alias).length)
    },
    setDefaultModal(){
      Object.assign(this.modalAddOrEdit, {
        showIndeterminateProgress: false,
        topSlotContentTitle: "Adicionar Processador",
        removeButtonClose: false,
        middleSlotContentTextHighlight: "",
        middleSlotContentText: "",
        bottomButtonsAlign: "right",
        bottomSlotContentButtonCancelLabel: "Cancelar",
        bottomSlotContentButtonConfirmLabel: "Salvar",
        middleCheckAgree: null,
        removeButtonCancel: false,
        removeButtonConfirm: false,
        onCancel: this.closeModalAddOrView,
        onConfirm: () => this.crudProcessor('create'),
        context: null
      })
    },
    closeModalAddOrView(){
      this.isModalAddOrViewActive = false
      if(this.$refs.formAddOrView){
        this.$refs.formAddOrView.reset()
      }
      this.processor = {}
      this.currentLog = {}
      this.processorObjectAreEdited = false
      this.setDefaultModal()
      this.updateProcessorApi = false
    },
    async changeModalContext(context, item = {}){
      if(context == 'create'){
        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Adicionar Processador",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Adicionar",
            middleSlotContentText: '',
            middleCheckAgree: null,
            onConfirm: () => this.crudProcessor('create'),
            context
          }
        )

        if(item){
          switch (item.className) {
            case 'initiator':
              Object.assign(this.processor, {
                initiator: this.getDefaultInitiatorValue(item.name)
              })
            break;
            case 'context':
              Object.assign(this.processor, {
                initiator: this.getDefaultInitiatorValue(item.initiator),
                context: item.name
              })
            break;
            case 'eventType':
              Object.assign(this.processor, {
                initiator: item.children.length ? this.getDefaultInitiatorValue(item.children[0].initiator) : this.getDefaultInitiatorValue(item.initiator),
                context: item.children.length ? item.children[0].context : item.context,
                eventType: item.name
              })
            break;
            case 'processor':
              Object.assign(this.processor, {
                initiator: this.getDefaultInitiatorValue(item.initiator),
                context: item.context,
                eventType: item.eventType,
                parent_processor: item.uuidProcessorConfiguration
              })
            break;
            default:
              Object.assign(this.processor, item)
            break;
          }
          this.$forceUpdate()
        }
      } else if(context == 'alias') {
        let aliasList = JSON.parse(item.alias)
        let aliasHtmlText = ''
        aliasList.forEach(alias => {
          aliasHtmlText += `<p>${alias}</p>`
        });

        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Lista de alias",
            bottomSlotContentButtonCancelLabel: "Fechar",
            middleSlotContentText: `<p class='my-6'>Estes originadores foram criados a partir de um originador já existente.</p> ${aliasHtmlText}`,
            removeButtonConfirm: true,
            middleCheckAgree: null,
            onConfirm: () => {},
            context
          }
        )
      } else if(context == 'delete') {
        Object.assign(this.processor, item)
        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Excluir Processador",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Excluir",
            middleCheckAgree: {
              "text": "Estou ciente de que após clicar no botão excluir, a ação não poderá ser desfeita.",
              "isChecked": false,
            },
            middleSlotContentText: `<p class='my-6'>Tem certeza que deseja <b>excluir o processador ${item.name}</b>?</p>`,
            onConfirm: () => this.crudProcessor('delete'),
            context
          }
        )
      } else if(context == 'update'){
        let result = await this.apiGetProcessorAssociationDetail(item.uuidProcessorConfiguration)
        let itemInitiator = item.initiator;

        this.processorDetail = JSON.stringify(result);
        this.$set(this.processor, 'initiator', itemInitiator && itemInitiator.name ? itemInitiator.name : itemInitiator)

        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Processador",
            middleSlotContentText: '',
            middleCheckAgree: null,
            disableBodyScroll: true,
            bottomButtonsAlign: 'left',
            bottomSlotContentButtonCancelLabel: "Fechar",
            onCancel: this.warningOnCancelModal,
            onConfirm: this.warningOnConfirmModal,
            context
          }
        )
        this.$forceUpdate()
      } else if (context == 'deploy') {
        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Deploy",
            bottomSlotContentButtonCancelLabel: "Cancelar",
            bottomSlotContentButtonConfirmLabel: "Confirmar",
            middleCheckAgree: null,
            middleSlotContentText: `<p class='my-6'>Tem certeza que deseja realizar o deploy do initiator <b>${item.name}</b> em produção?</p>`,
            onConfirm: () => this.deployInitiator(item.name),
            context
          }
        )
      } else if (context == 'deploySucess') {
        Object.assign(this.modalAddOrEdit,
          {
            ...this.modalAddOrEdit,
            topSlotContentTitle: "Sucesso",
            bottomSlotContentButtonCancelLabel: "Fechar",
            removeButtonConfirm: true,
            middleCheckAgree: null,
            middleSlotContentText: `<p class='my-6'>O <b>deploy</b> do initiator <b>${item.initiator}</b> foi gerado com sucesso, consulte o pull request no Github:<br><br>Link: <a target="_blank" href="${item.url}">${item.url}</a></p>`,
            onConfirm: () => {},
            context
          }
        )
      }
      this.isModalAddOrViewActive = true
    },
    checkAgree(value) {
      if(this.modalAddOrEdit.middleCheckAgree){
        this.$set(this.modalAddOrEdit.middleCheckAgree, 'isChecked', value)
        this.$forceUpdate()
      }
    },
    async crudProcessor(action){
      const responseMsg = {
        'create': ['criado', 'criar'],
        'delete': ['excluído', 'excluir'],
        'update': ['editado', 'editar']
      }

      try {
        switch(action){
          case 'create':
            const payload = {
              ...this.processor,
              context: this.processor.context.replace(/\t/g, ''),
              initiator: typeof this.processor.initiator == 'object' ? this.processor.initiator.code : this.processor.initiator
            }
            await this.apiCreateProcessorAssociation(payload)
            this.closeModalAddOrView()
          break
          case 'update':
            this.updateProcessorApi = false
            await this.apiUpdateProcessorAssociationDetail(this.processor)
            let result = await this.apiGetProcessorAssociationDetail(this.processor.processorConfUuid)
            this.processorDetail = JSON.stringify(result);
            this.processorObjectAreEdited = false
            this.updateProcessorApi = true
          break
          case 'delete':
            await this.apiDeleteProcessorAssociation(this.processor.uuidProcessorConfiguration)
            this.closeModalAddOrView()
          break
        }
        this.showFeedback({
          color: "success",
          message: `Processador ${responseMsg[action][0]} com sucesso!`,
        })
        await this.apiGetProcessorAssociations()
      } catch (error) {
        let errorMsg = `Erro ao ${responseMsg[action][1]} processador!`

        if(error.response.status === 400 && error.response.data && error.response.data.message) {
          errorMsg = error.response.data.message
        }

        this.showFeedback({
          color: "error",
          message: errorMsg,
        })
      }
    },
    async deployInitiator(initiator) {
      try {
        const response = await this.apiDeployInitiator(initiator)
        const item = {
          initiator: initiator,
          url: response.url
        }
        this.closeModalAddOrView()
        this.changeModalContext('deploySucess', item)
      } catch (error) {
        this.closeModalAddOrView()
        this.showFeedback({
          color: "error",
          message: 'Initiator não encontrado.',
        })
      }

    },
    applyFilter(){
      this.filtersSelected.push(this.modelFilter)
      this.filterMenu = false
      this.modelFilter = ''
    },
    removeFilterList(index) {
      if(this.filtersSelected.length == 1){
        this.filtersSelected = ['DEFAULT']
      } else{
        this.filtersSelected.splice(index, 1)
      }
    },
    getDefaultInitiatorValue(value){
      return value ? value : {"code": "","name": "DEFAULT"}
    },
    updateProcessorObjetc(value){
      this.processor = {
        initiator: this.processor.initiator,
        ...value
      }
      this.processorObjectAreEdited = JSON.stringify(value) !== this.processorDetail ? true : false
    },
    closeSimpleModal(){
      Object.assign(this.simpleModal, {
        active: false
      })
    },
    warningOnCancelModal(){
      if(this.processorObjectAreEdited){
        Object.assign(this.simpleModal, {
          active: true,
          topSlotContentTitle: "Alterações não salvas",
          middleSlotContentText: "<p>Você fez alterações que ainda não foram salvas no processador.</p><br /><p><b>Ao fechar, todas as alterações serão perdidas</b>.</p><br /><p>Deseja fechar o modal sem salvar as mudanças?</p>",
          bottomSlotContentButtonConfirmLabel: "Fechar mesmo assim",
          showIndeterminateProgress: false,
          removeButtonCancel: false,
          removeButtonConfirm: false,
          onConfirm: () => {
            this.closeSimpleModal()
            this.closeModalAddOrView()
          },
          onCancel: () => this.closeSimpleModal()
        })
      } else {
        this.closeModalAddOrView()
      }
    },
    warningOnConfirmModal(){
      if(this.currentLog.index && this.currentLog.index !== 0){
        Object.assign(this.simpleModal, {
          active: true,
          topSlotContentTitle: "Restaurar Histórico",
          middleSlotContentText: `<p>Você selecionou a versão do processador de <b>${this.currentLog.date}</b>.</p><br /><p><b>Ao salvar, você vai restaurar este histórico selecionado</b>.</p><br /><p>Deseja salvar essas mudanças?</p>`,
          bottomSlotContentButtonConfirmLabel: "Restaurar",
          showIndeterminateProgress: false,
          removeButtonCancel: false,
          removeButtonConfirm: false,
          onConfirm: () => {
            this.closeSimpleModal()
            this.crudProcessor('update')
          },
          onCancel: () => this.closeSimpleModal()
        })
      } else {
        this.crudProcessor('update')
      }
    },
    onChangeLog(value){
      this.currentLog = Object.assign({}, value)
    },
    cancelExportYaml(){
      this.enableExport = false
      this.itemsSelected = []
    },
    async downloadYaml(item){
      try {
        await this.apiGetConfigTree({
          initiator: item.name,
          processors: this.parseItemsSelected
        })
        this.cancelExportYaml()
      } catch (error) {
        this.showFeedback({
          color: "error",
          message: `Erro ao exportar YAML: ${error}`,
        })
      }
    },
    cancelCopyAction(){
      this.pasteClassList = []
      this.auxPasteItem = 0
      this.currentCopiedNode = {}
      this.cancelExportYaml()
    },
    pasteItem(item){
      this.pasteClassList = []
      this.auxPasteItem = 0

      Object.assign(this.simpleModal, {
        active: true,
        topSlotContentTitle: "Copiar/Colar",
        middleSlotContentText: "<p>Estamos copiando e colando os itens que você selecionou, aguarde até que o processo finalize.</p><br /><p><b>Não feche ou recarrege a página até que o processo seja concluído</b>.</p><br />",
        showIndeterminateProgress: true,
        removeButtonCancel: true,
        removeButtonConfirm: true,
        onConfirm: () => null,
        onCancel: () => null
      })

      this.findAndCreateNewItemRecursive(this.currentCopiedNode, item.className, item)
    },
    async findAndCreateNewItemRecursive(item, type, itemWherePaste, parent = null){
      while(item.children) {
        if(item.className == 'processor') {
          const { alias, eventProcessor, executionStep, matchers, name, uuidProcessorConfiguration } = item
          let processConfiguration = {
            alias,
            eventProcessor,
            executionStep,
            matchers,
            initiator: itemWherePaste.initiator,
            context: itemWherePaste.context,
            eventType: itemWherePaste.eventType
          }

          switch (itemWherePaste.className) {
            case 'processor':
              processConfiguration['parent_processor'] = itemWherePaste.uuidProcessorConfiguration
            break;
            case 'eventType':
              processConfiguration['eventType'] = itemWherePaste.name
            break;
            case 'context':
              processConfiguration['eventType'] = item.eventType
              processConfiguration['context'] = itemWherePaste.name
            break;
            case 'initiator':
              processConfiguration['eventType'] = item.eventType
              processConfiguration['context'] = item.context
              processConfiguration['initiator'] = itemWherePaste.initiator || itemWherePaste.name
            break;
          }

          if(parent) {
            processConfiguration['parent_processor'] = parent
          }
          try {
            const result = await this.apiCreateProcessorAssociation(processConfiguration)
            this.currentUuidProcessor = result.headers.location.split('/').reverse()[0];
            this.getAndUpdateParamsProcessor(uuidProcessorConfiguration, this.currentUuidProcessor)
          } catch(error) {
            this.closeSimpleModal()
            this.showFeedback({
              color: "error",
              message: `Erro ao salvar ProcessConfiguration: ${error}`
            })
            throw error
          }
        }

        item = item.children

        if(item.length) {
          this.auxPasteItem = this.auxPasteItem + item.length
          for(var i = 0; i < item.length; i++){
            this.findAndCreateNewItemRecursive(item[i], type, itemWherePaste, this.currentUuidProcessor)
          }
        }
      }

      this.auxPasteItem--;
      if(this.auxPasteItem == -1) {
        await this.apiGetProcessorAssociations()
        this.closeSimpleModal()
        this.showFeedback({
          color: "success",
          message: "ProcessConfiguration colado com sucesso!"
        })
      }
    },
    async getAndUpdateParamsProcessor(uuidProcessorConfiguration, currentUuidProcessor){
      const paramsProcessor = await this.apiGetProcessorAssociationDetail(uuidProcessorConfiguration)
      const currentParamsProcessor = await this.apiGetProcessorAssociationDetail(currentUuidProcessor)

      if(paramsProcessor.processorParams.length){
        const newParamProcessor = {
          ...currentParamsProcessor,
          processorParams: paramsProcessor.processorParams
        }
        await this.apiUpdateProcessorAssociationDetail(newParamProcessor)
      }
    },
    getDiffValues(values) {
      let { old, newTransformed, newOriginal } = values
      this.oldValue = this.stringifyValue(old)
      this.newValue = this.stringifyValue(newTransformed)
      this.newOriginal = newOriginal
      this.isDiffModalActive = true;
    },
    hasChangeOptionValue(){
      this.transformLocalStorage = this.getInputsTransformLocalStorage()
    },
    async hasChangedOutputValues({ configObject }){
      let { schema , options } = configObject
      let payload = {
        "schema": schema,
        "input": this.newOriginal
      }
      if(options){
        payload.options = {
          "import_schemas": options
        }
      }

      localStorage.setItem("idt-inputs-transform-processor", this.stringifyValue({...payload}))

      try {
        let result = await this.apiTransformSchemaMessage(payload)
        this.newValue = this.stringifyValue(result)
      } catch (error) {
        this.newValue = null
        let errorMsg = {
          "400": "Não foi possível transformar a saída.",
          "404": "Schema/Message não encontrado(s)."
        }
        this.showFeedback({
          color: "error",
          message: errorMsg[error.response.status] || 'Erro ao transformar saída.'
        })
      }
    },
    encodeDecodeBase64(){
      if(this.isBase64) {
        this.newValue = this.decodeByte(this.newOriginal);
      } else {
        this.newValue = this.newOriginal;
      }
      this.isBase64 = !this.isBase64
    }
  }
}
</script>
<style>
  .processor-item-tree:hover {
    cursor: pointer;
  }
  .v-treeview:focus,
  .v-treeview:focus-within,
  .v-treeview:focus-visible {
    outline: none;
  }
</style>

